export default "__VITE_ASSET__0e7ae8f5__"